module.exports = __webpack_public_path__ + "static/media/t.8ed1ca88.svg";